import { useEffect, useRef } from 'react';

// use this trick to prevent warning from eslint
const bypassWarningUseEffect: typeof useEffect = useEffect;

/** A utility hook to be used when you have a useEffect with dependencies,
 * but you don't want to run the effect when the component  is mounted
 * */
export const useSkipEffectOnMount: typeof useEffect = (effect, deps) => {
  const mountedRef = useRef(false);
  bypassWarningUseEffect(() => {
    if (mountedRef.current) {
      return effect();
    }
  }, deps);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
};
